<div [formGroup]="cartForm">
    <div class="cart-wizard-section-card">
        <div class="cart-wizard-section-heading ad-spend-shell" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div class="cart-wizard-section-heading__copy">
                <strong class="cart-wizard-section-heading__title">{{(addingFacebook || addingGoogle) ? ('SELECT_YOUR_AD_SPEND' | translate) : ('REVIEW_YOUR_PRODUCTS' | translate)}}</strong>
                <p class="cart-wizard-section-heading__subtitle">{{ 'CONFIRM_PRODUCTS' | translate }}</p>
            </div>
        </div>
        <div formArrayName="stepsData" class="steps-data-container" fxLayout="column" fxLayoutAlign="start center">
            <div class="ad-spend-products-row" fxLayout="row wrap" fxLayoutAlign="center stretch" fxLayoutGap="24px grid">
                <!-- Non-management-fee products -->
                <ng-container *ngFor="let item of nonManagementFeeProducts; trackBy: trackByProduct">
                    <div class="ad-spend-product-shell">
                        <div [formGroupName]="item.i" [ngClass]="(item.ctrl?.get('includeProduct')?.value) ? 'product-card cart-wizard-choice-card' : 'product-card cart-wizard-choice-card cart-wizard-choice-card--muted'" fxLayout="column" fxFlex>
                        <div class="product-header" fxLayout="row" fxLayoutAlign="center start">
                            <h4>{{item.ctrl.get('display')?.value}}</h4>
                        </div>
                        <div class="product-image-container" fxLayout="column" fxLayoutAlign="start center">
                            <img [src]="item.ctrl.get('mediaUrl')?.value" class="product-image">
                        </div>
                        <div class="product-description" fxLayout="row" fxLayoutAlign="center center">
                            <p>{{item.ctrl.get('description')?.value}}</p>
                        </div>
                        <div class="switch-container" *ngIf="(stepsData.controls.length > 1) && item.ctrl.get('isRequired') !==null && item.ctrl.get('isRequired')?.value === false"
                            fxLayout="row" fxLayoutAlign="center center">
                                <label>{{ 'INCLUDE_THIS_PRODUCT' | translate }}</label>
                                <ui-switch (valueChange)="onSwitchChange($event,item.i)"
                                    size="small" defaultBoColor="#dfdfdf"
                                    color="#4ba6ef"
                                    [checked]="item.ctrl?.get('includeProduct')?.value"
                                    checkedLabel="{{ 'YES' | translate }}" uncheckedLabel="{{ 'NO' | translate }}" class="ms-1">
                                </ui-switch>
                        </div>
                        <div class="product-price-shell">
                            <h4 *ngIf="item.ctrl.value.price != null && !showRecurring()" class="product-price">
                                ${{item.ctrl.value.price}}
                            </h4>
                            <h4 *ngIf="item.ctrl.value.price != null && showRecurring()" class="product-price">
                                {{item.ctrl.value.price | currency:'USD' : 'symbol' : '1.0-0'}} {{ 'PER' | translate }} {{translateDuration(item.ctrl.value.duration)}}
                            </h4>
                        </div>
                        <div *ngIf="(item.ctrl.get('type')?.value === PRODUCT_TYPES.VariableSubscription.code) && (!hasGoogle && !hasFacebook)"
                            class="ad-spend-section" fxLayout="column" fxLayoutAlign="center center">
                            <label>{{ 'MONTHLY_AD_SPEND' | translate }}</label>
                            <div>
                                <ng-select
                                    formControlName="adSpend"
                                    [items]="productAdSpendOptions.get(item.ctrl.get('id')?.value) || []"
                                    [clearable]="false"
                                    [searchable]="false"
                                    [appendTo]="'body'"
                                    class="ad-spend-select"
                                    (change)="doFinalizeProducts()">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{ item | currency:'USD' : 'symbol' : '1.0-0' }}
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        {{ item | currency:'USD' : 'symbol' : '1.0-0' }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        </div>
                    </div>
                </ng-container>
                <!-- Management-fee products at the end of the row -->
                <ng-container *ngFor="let item of managementFeeProducts; trackBy: trackByProduct">
                                <div class="ad-spend-product-shell">
                    <div [formGroupName]="item.i"
                        class="product-card cart-wizard-choice-card cart-wizard-choice-card--muted no-shadow"
                        fxLayout="column"
                        fxFlex>
                        <div class="product-header" fxLayout="row" fxLayoutAlign="center start">
                            <h4>{{item.ctrl.get('display')?.value}}</h4>
                        </div>
                        <div class="product-image-container" fxLayout="column" fxLayoutAlign="start center">
                            <img [src]="item.ctrl.get('mediaUrl')?.value" class="product-image">
                        </div>
                        <div class="product-description" fxLayout="row" fxLayoutAlign="center center">
                            <p>{{item.ctrl.get('description')?.value}}</p>
                        </div>

                        <div class="product-price">
                            <h4>
                                {{item.ctrl.value.price | currency:'USD' : 'symbol' : '1.0-0'}} {{ 'PER' | translate }} {{translateDuration(item.ctrl.value.duration)}}
                            </h4>
                            <h5 *ngIf="item.ctrl.value.signupFee && item.ctrl.value.signupFee > 0" class="setup-price">
                                +{{item.ctrl.value.signupFee | currency:'USD' : 'symbol' : '1.0-0'}} {{ 'SETUP_FEE' | translate }}
                            </h5>
                        </div>
                    </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="cart-wizard-actions" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <button class="orange-button cart-wizard-action-btn" type="button" (click)="onPrevious();">{{ 'BACK' | translate }}</button>
            <button type="button" (click)="onContinue();"
            [class]="(((!hasFacebook) && (!hasGoogle)) || (!addingFacebook && !addingGoogle)) ? 'orange-button cart-wizard-action-btn' : 'grey-button cart-wizard-action-btn'">{{ 'CONTINUE_TO_CART' | translate }}</button>
        </div>
    </div>
</div>
